export const selectProducts = state => state.product.products;